import { ReactElement, PropsWithChildren, useMemo } from 'react';

import BackButton from '../../BackButton';
import MoneytreeIcon from '../../MoneytreeIcon';
import SproutLogo from '../../SproutLogo';

import './styles.scss';

export interface IProps {
  className?: string;
  showBackButton?: boolean;
  title?: string;
}

export default function Header({
  children,
  className = '',
  showBackButton = false,
  title = ''
}: PropsWithChildren<IProps>): ReactElement {
  const logo = useMemo(
    () =>
      title ? (
        <MoneytreeIcon className="moneytree-icon" />
      ) : (
        <SproutLogo className="moneytree-logo" />
      ),
    [title]
  );

  return (
    <div className={`header ${className}`}>
      <div className="left-content">
        {showBackButton && <BackButton />}
        {!showBackButton && logo}
        {title && <span className="title">{title}</span>}
      </div>
      {children}
    </div>
  );
}
